const validation = {
    email: {
      presence: {
        allowEmpty: false,
        message: '^Please enter an email address'
      },
      email: {
        message: '^Please enter a valid email address'
      }
    },
    
    password: {
      presence: {
        allowEmpty: false,
        message: '^Please enter a password'
      },
      length: {
        minimum: 6,
        message: '^Your password must be at least 6 characters'
      }
    },

    names: {
      presence: {
        allowEmpty: false,
        message: '^Please enter a name'
      },
      length: {
        minimum: 1,
        message: '^Please enter a valid name'
      }
    },

    text: {
      presence: {
        allowEmpty: false,
        message: '^Field cannot be empty, Please enter correct info'
      },
      length: {
        minimum: 1,
        message: '^Text is to short, Please enter valid info'
      }
    },

    number: {
      presence: {
        noStrings:true,
        allowEmpty: false,
        message: '^Please enter a number'
      },
    },
    
     country: {
      presence: {
        allowEmpty: false,
        message: '^Please select a country'
      },
      length: {
        minimum: 1,
        message: '^Please enter a valid name'
      }
      // length: {
      //   minimum: 1,
      //   message: '^Please enter a valid name'
      // }
    },

    allowTCs: {
        presence: {
            message: "^You need to accept the terms and conditions to use this service."
        },
        inclusion: {
            within: [true],
            message: "^You need to accept the terms and conditions to use this service."
        }
    }
  }
  
  export default validation



// WEBPACK FOOTER //
// ./src/actions/validation.js